import { Component, OnInit } from '@angular/core';
import { CoreLanguageService } from '../../services/language.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'reconnectDialog',
  templateUrl: './reconnectDialog.component.html',
  styleUrls: ['./reconnectDialog.component.scss']
})

export class ReconnectDialogComponent implements OnInit {
  constructor(
    private _coreLanguageService: CoreLanguageService,
    private dialogRef: MatDialogRef<ReconnectDialogComponent>,
  ) { }

  ngOnInit() {
    const me = this;
  }

}